import { Component, computed, input } from '@angular/core';
import { ChartsHelper } from '@app/app/shared/helpers/charts-helper';
import { GoalResponse } from '@app/app/shared/models';

@Component({
  selector: 'ptl-content-item-progress',
  templateUrl: './content-item-progress.component.html',
  styleUrls: ['./content-item-progress.component.scss'],
})
export class ContentItemProgressComponent {
  goal = input<GoalResponse | null>(null);

  goalCompletedPercentage = computed(() => {
    const goal = this.goal();

    if (!goal || goal.completedCards === 0) {
      return 0;
    }
    return ChartsHelper.calculateProgress(goal.completedCards, goal.totalCards);
  });
}
